import { __awaiter, __generator } from "tslib";
import { MicroSyncMessage } from '@augloop/session-protocol';
import { SchemaObject, AddOperation, UpdateOperation } from '@augloop/types-core';
import { VoiceTile, VoiceOperation, BatchTranscriptionConversation, } from '@augloop-types/voice';
import { AUDIO_SAMPLE_RATE } from './AudioUtils';
export var AugloopError;
(function (AugloopError) {
    AugloopError["ErrorAugloopActivateAnnotations"] = "ErrorAugloopActivateAnnotations";
})(AugloopError || (AugloopError = {}));
// Activate SpeechToText annotations in our AL runtime mananger.
// Returns the activation token.
export var activateAnnotationAsync = function (alRuntimeManager, annotationTypeName) { return __awaiter(void 0, void 0, void 0, function () {
    var activationResult;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, alRuntimeManager.activateAnnotation({
                    annotationType: annotationTypeName,
                })];
            case 1:
                activationResult = _a.sent();
                return [2 /*return*/, activationResult.token];
        }
    });
}); };
export var releaseAnnotations = function (alRuntimeManager, activationTokens) {
    activationTokens.map(function (token) {
        // tslint:disable-next-line: no-floating-promises (TODO: verify we can let this promise float here)
        alRuntimeManager.releaseAnnotation({ token: token });
    });
};
// Send an empty tile to ensure connection to AL and our audio processor, so we do not have to wait on
// mic permissions and the audio buffer to fill
export var startAudioProcessor = function (alRuntimeManager, useFrontdoorWorkflow, dictationSettings, responseVersion) {
    var voiceTile = new VoiceTile({
        sampleRate: AUDIO_SAMPLE_RATE,
        useFrontdoorWorkflow: useFrontdoorWorkflow,
        dictationSettings: dictationSettings,
        responseVersion: responseVersion,
    });
    var voiceOperation = new VoiceOperation({
        parentPath: ['session'],
        items: [
            {
                id: 'voiceTile',
                body: voiceTile,
            },
        ],
    });
    alRuntimeManager.submitOperation({ operation: voiceOperation });
};
// Create and submit a voice tile with the provided audio data.
export var submitVoiceTile = function (alRuntimeManager, voiceData, audioSampleRate, useFrontdoorWorkflow, sequence, dictationSettings, endVoiceSession, responseVersion, speechToTextProfile) {
    var microSync = new MicroSyncMessage({
        item: {
            id: sequence.toString(),
            body: new VoiceTile({
                sampleRate: audioSampleRate,
                useFrontdoorWorkflow: useFrontdoorWorkflow,
                seq: sequence,
                dictationSettings: dictationSettings,
                endVoiceSession: endVoiceSession,
                responseVersion: responseVersion,
                data: new Uint8Array(voiceData.buffer, voiceData.byteOffset, voiceData.byteLength),
                speechToTextProfile: speechToTextProfile,
            }),
        },
    });
    // This will produce an error when a confirmation response is not returned from the client
    // We are currently logging this, but in the future we should likely end dictation after a number
    // of consecutive errors produced here indicating AL is not responding to our messages
    alRuntimeManager.submitCustomMessage({ message: microSync }).catch();
};
export function submitBatchTranscriptionConversation(alRuntimeManager, conversationId, tileId, speechFDUrl) {
    var operation = new AddOperation({
        parentPath: ['session'],
        items: [
            {
                id: tileId,
                body: new BatchTranscriptionConversation({
                    conversationId: conversationId,
                    speechFDUrl: speechFDUrl,
                }),
            },
        ],
    });
    alRuntimeManager.submitOperation({ operation: operation });
}
// Given an operation, filter items by annotation type Add Operation or Upate Operation.
export var filterOperationByAnnotationTypeName = function (operation, annotationTypeName) {
    if (SchemaObject.getTypeNameFor(operation) !== AddOperation.getTypeName() &&
        SchemaObject.getTypeNameFor(operation) !== UpdateOperation.getTypeName()) {
        return [];
    }
    if (operation.items.length === 0)
        return [];
    var filteredItems = operation.items.filter(function (item) { return item.body && SchemaObject.getTypeNameFor(item.body) === annotationTypeName; });
    return filteredItems;
};
//# sourceMappingURL=AugLoopUtils.js.map